module.exports = __webpack_public_path__ + "img/skillsB-3.e80906e2.png";